'use es6';

import { // TODO: Deprecate when IDE is open to all portals.
LAYOUT_GROUPING_TOGGLE, LAYOUT_GROUPING_TOGGLE_WIDGET // Layout editor multi-select
, LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS, LAYOUT_EDITOR_SESSION_CLEAR_WIDGET_SELECTIONS, LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION, LAYOUT_EDITOR_SESSION_REMOVE_WIDGET_SELECTION, LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION // Layout revision mode (de)activated
, LAYOUT_EDITOR_SESSION_REVISION_ACTIVATE, LAYOUT_EDITOR_SESSION_REVISION_DEACTIVATE // Unifie layouts fetch
, UNIFIED_LAYOUT_FETCH, LAYOUT_DELETE } from 'DesignData/actions/ActionTypes';
import { validated, remove } from 'DesignData/actions/LayoutGrouping';
import { validate } from 'DesignData/lib/layouts/widgets/grouping';
import { makeGetSelectedWidgetsAsLayoutWidgets, getRevisionMode } from 'DesignData/selectors/layoutEditorSession';
const getSelectedWidgetsAsLayoutWidgets = makeGetSelectedWidgetsAsLayoutWidgets();
/*
 * Get list of selected widgets from state.
 * - DMUI: state.layoutGrouping
 */

const getSelectedWidgetListFromState = (state, layoutId) => {
  const {
    order
  } = getSelectedWidgetsAsLayoutWidgets(state, {
    layoutId
  });
  return order;
};
/*
 *
 */


export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const state = getState();
  /*
   * Validate selections
   */

  switch (result.type) {
    // TODO: Deprecate the following two actions with DMUI
    case LAYOUT_GROUPING_TOGGLE:
    case LAYOUT_GROUPING_TOGGLE_WIDGET:
    case LAYOUT_EDITOR_SESSION_REVISION_DEACTIVATE:
    case LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS:
    case LAYOUT_EDITOR_SESSION_CLEAR_WIDGET_SELECTIONS:
    case LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION:
    case LAYOUT_EDITOR_SESSION_REMOVE_WIDGET_SELECTION:
    case LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION:
    case UNIFIED_LAYOUT_FETCH:
      {
        const {
          layoutId
        } = result;
        const {
          revisionId
        } = getRevisionMode(state, {
          layoutId
        });

        if (revisionId) {
          break;
        }

        const widgetList = getSelectedWidgetListFromState(state, layoutId);
        const validatedLayoutGroup = validate(state, layoutId, widgetList);
        dispatch(validated(layoutId, validatedLayoutGroup));
        break;
      }

    case LAYOUT_DELETE:
    case LAYOUT_EDITOR_SESSION_REVISION_ACTIVATE:
      {
        const {
          layoutId
        } = result;
        dispatch(remove(layoutId));
        break;
      }

    default:
      break;
  }

  return result;
});